import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

const URL = process.env.REACT_APP_NODE_ENV === 'development'
  ? 'http://localhost:8008'
  : 'https://australia-southeast1-product-sync-handler.cloudfunctions.net/establish-monday-webhooks';

export default ({ onSettled, onSuccess, onError }) => useMutation({
  mutationKey: ['establish_monday_webhooks'],
  mutationFn: async () => (await axios({
    method: 'POST',
    url: URL,
  })).data,
  onSettled,
  onSuccess,
  onError,
});
